fragment CollectionTitleFragment on collectionTitle_Entry {
  typeHandle
  heading
  teaserText
  showScrolldown
}
